import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { Buffer } from 'buffer';

type PresignData = {
    url: string;
    fields: {
        key: string;
        bucket: string;
        "X-Amz-Algorithm": string;
        "X-Amz-Credential": string;
        "X-Amz-Date": string;
        Policy: string;
        "X-Amz-Signature": string;
    };
};


type RequestPresignBody = {
    fileSize: Number,
    key: String
}

const getDataURLBytes = (dataURL: string): number => {
    console.log('find URL Bytes')
    // Extract the data portion of the URL
    const dataPortion = dataURL.split(',')[1];

    // Decode the base64 data using Buffer
    const buffer = Buffer.from(dataPortion, 'base64');

    // Calculate the file size in bytes
    const fileSizeBytes = buffer.length;

    return fileSizeBytes;
}

const getFileNameWithoutExtension = (filename: string) => {
    // Use a regular expression to match the filename and extension
    const regex = /(.+?)(\.[^.]*$|$)/;

    // Use the 'match' method to extract the filename and extension
    const match = filename.match(regex);

    // If the filename has an extension, return the part before the last dot; otherwise, return the whole filename
    return match ? match[1] : filename;
}

export const requestPresign = async (url, payload: RequestPresignBody, accessToken: String) => {
    const { fileSize, key } = payload

    const { data: responseData } = await axios.post(url, {
        fileSize,
        key
    }, {
        headers: {
            'Authorization': `Bearer ${accessToken}`
        }
    })

    const { data } = responseData
    return data
}



export const doPresign = async (data: PresignData, file) => {
    const formData = new FormData()
    const filename = data.fields.key

    Object.keys(data.fields).forEach(key => {
        formData.append(key, data.fields[key])
    })

    formData.append('file', file, filename)

    await axios.post(data.url, formData, {
        headers: {
            'Content-Type': 'application/octet-stream',
            'Content-Disposition': `attachment; filename=${filename}`,
            'Authorization': ''
        }
    })

    return getFileNameWithoutExtension(filename);
}